import React from 'react';

import { twMerge } from 'tailwind-merge';

import Icon from '../icon/icon';

type SortArrowProps = {
  state: 'up' | 'down' | 'none';
  onUpArrowClicked?: () => void;
  size?: number;
  className?: string;
};

const SortArrow: React.FC<SortArrowProps> = (props) => {
  const { state, onUpArrowClicked, size } = props;

  const upArrowColor = state === 'up' ? '#43344D' : '#979699';

  const downArrowColor = state === 'down' ? '#43344D' : '#979699';

  return (
    <button
      className={twMerge('flex flex-col', props.className)}
      type="button"
      onClick={onUpArrowClicked}
    >
      <Icon
        icon="caret-down"
        color={upArrowColor}
        className={twMerge('-rotate-180')}
        size={size}
      />
      <Icon icon="caret-down" color={downArrowColor} size={size} />
    </button>
  );
};

export default SortArrow;
